@if (content) {
<div class="_container pos-relative">
    <df-image-wrapper class="fill">
        <img [ratio]="16/9"
             [dfImage]="content.image"
             [fill]="true">
    </df-image-wrapper>

    <div class="fill z-2"
         [style.background-color]="'rgba( ' + (content.darkContrast ? '0, 0, 0' : '255, 255, 255') + ', ' + content.overlayOpacity + ')'"
         [style.backdrop-filter]="'blur(' + (content.blur ? '1px' : '0px') + ')'">
    </div>
    <div class="pos-absolute left-0 right-0 bottom-10 z-3 p-r-9 p-l-9 flex-column flex-middle center"
         [ngClass]="content.darkContrast ? 'col-w' : 'col-1'"
         [style.min-height.px]="content.icon ? 372 : 275">
        @if (content.icon) {
        <div class="inline-flex b-radius-max p-a m-b-5"
             [ngClass]="content.darkContrast ? 'bg-col-w' : 'bg-col-1'">
            <i class="inline-flex"
               [ngClass]="[content.darkContrast ? 'col-1' : 'col-w', content.icon]"
               style="font-size: 24px;"></i>
        </div>
        }
        <p *iCms="'title' of content; content: 'html'"
           class="h3"></p>
        <p *iCms="'description' of content; content: 'html'"
           class="m-t-2 p2"></p>
        <a class="button w-12 m-t-9 block"
           [routerLink]="'/first-mission'">
            <span *iCms="'continueButtonText' of content"></span>
        </a>
    </div>
</div>
}
